import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const TrStyled = styled.tr`
	background: ${color.primary};
	color: ${color.black} !important;

	th {
		padding: 10px !important;

		&:not(:last-child) {
			border-right: 1px solid ${color.black} !important;
		}

		&::after {
			width: 0 !important;
		}
	}
`;

export const TheadStyled = styled.thead``;
